import { render } from "./AdminDataTableHeader.vue?vue&type=template&id=2961d355&scoped=true"
import script from "./AdminDataTableHeader.vue?vue&type=script&lang=js"
export * from "./AdminDataTableHeader.vue?vue&type=script&lang=js"

import "./AdminDataTableHeader.vue?vue&type=style&index=0&id=2961d355&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2961d355"]])

export default __exports__